import { imageSource } from "@app/constants";
import { PATH_DASHBOARD } from "@app/routes/paths";

export const slideData = [
  {
    title: "Search",
    compareLabels: "Select And",
    yourRide: "buy a bike",
    subtitle: "Easily",
    description:
      "10,000+ verified cars & bikes — from new rides & trusted ones. Find your perfect match anywhere in Bangalore",
    buttonLabel: "Explore",
    image: imageSource.scootyRide,
    path: "https://www.matter.in/",
    isOuterRefrence: true,
  },
  {
    title: "Search",
    compareLabels: "Select And",
    yourRide: "buy a car",
    subtitle: "Easily",
    description:
      "10,000+ verified cars & bikes — from new rides & trusted ones. Find your perfect match anywhere in Bangalore",
    buttonLabel: "Explore",
    image: imageSource.white_fortuner,
    path: PATH_DASHBOARD.home,
    isOuterRefrence: false,
  },
  {
    title: "Search",
    compareLabels: "Select And",
    yourRide: "buy a car",
    subtitle: "Easily",
    description:
      "10,000+ verified cars & bikes — from new rides & trusted ones. Find your perfect match anywhere in Bangalore",
    buttonLabel: "Explore",
    image: imageSource.black_fortuner,
    path: PATH_DASHBOARD.home,
    isOuterRefrence: false,
  },
];
